import { render, staticRenderFns } from "./Georreferencer.vue?vue&type=template&id=521b93f0&scoped=true&"
import script from "./Georreferencer.vue?vue&type=script&lang=js&"
export * from "./Georreferencer.vue?vue&type=script&lang=js&"
import style0 from "./Georreferencer.vue?vue&type=style&index=0&id=521b93f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521b93f0",
  null
  
)

export default component.exports